import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{
      background: 'linear-gradient(135deg, #064e3b 0%, #065f46 100%)',
      color: 'white',
      padding: '3rem 2rem 1.5rem',
      marginTop: 'auto'
    }}>
      <div style={{maxWidth: '1200px', margin: '0 auto'}}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem'
        }}>
          <div>
            <h3 style={{fontSize: '1.25rem', fontWeight: '700', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
              <span style={{fontSize: '1.5rem'}}>💼</span>
              Miranda Landa Services LLC
            </h3>
            <p style={{color: '#d1fae5', fontSize: '0.9rem', lineHeight: '1.6'}}>
              Professional business capital consulting and strategic funding advisory services.
            </p>
          </div>
          
          <div>
            <h4 style={{fontSize: '1rem', fontWeight: '600', marginBottom: '1rem'}}>Quick Links</h4>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem'}}>
              <Link to="/about" style={{color: '#d1fae5', fontSize: '0.9rem'}}>About Us</Link>
              <Link to="/services" style={{color: '#d1fae5', fontSize: '0.9rem'}}>Services</Link>
              <Link to="/blog" style={{color: '#d1fae5', fontSize: '0.9rem'}}>Blog</Link>
              <Link to="/faq" style={{color: '#d1fae5', fontSize: '0.9rem'}}>FAQ</Link>
              <Link to="/contact" style={{color: '#d1fae5', fontSize: '0.9rem'}}>Contact</Link>
            </div>
          </div>
          
          <div>
            <h4 style={{fontSize: '1rem', fontWeight: '600', marginBottom: '1rem'}}>Legal</h4>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem'}}>
              <Link to="/privacy" style={{color: '#d1fae5', fontSize: '0.9rem'}}>Privacy Policy</Link>
              <Link to="/terms" style={{color: '#d1fae5', fontSize: '0.9rem'}}>Terms & Conditions</Link>
              <Link to="/sms-policy" style={{color: '#d1fae5', fontSize: '0.9rem'}}>SMS Policy</Link>
              <Link to="/sms-consent" style={{color: '#d1fae5', fontSize: '0.9rem'}}>SMS Consent & Opt-Out</Link>
              <Link to="/cookie-policy" style={{color: '#d1fae5', fontSize: '0.9rem'}}>Cookie Policy</Link>
            </div>
          </div>
          
          <div>
            <h4 style={{fontSize: '1rem', fontWeight: '600', marginBottom: '1rem'}}>Contact</h4>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem'}}>
              <a href="mailto:info@mirandaconnects.com" style={{color: '#d1fae5', fontSize: '0.9rem'}}>
                📧 General: info@mirandaconnects.com
              </a>
              <a href="mailto:support@mirandaconnects.com" style={{color: '#d1fae5', fontSize: '0.9rem'}}>
                📧 Support: support@mirandaconnects.com
              </a>
              <p style={{color: '#d1fae5', fontSize: '0.9rem', margin: 0}}>
                🕐 Response: Within 24 hours
              </p>
              <p style={{color: '#d1fae5', fontSize: '0.9rem', margin: 0}}>
                Mon-Fri: 9AM-6PM EST
              </p>
            </div>
          </div>
        </div>
        
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.2)',
          paddingTop: '1.5rem',
          textAlign: 'center',
          color: '#d1fae5',
          fontSize: '0.875rem'
        }}>
          <p>&copy; {new Date().getFullYear()} Miranda Landa Services LLC. All rights reserved.</p>
          <p style={{marginTop: '0.5rem'}}>We are a consulting firm, not a lender. All financing decisions are made by partnered financial institutions.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
